import { createEvent, createStore, createEffect, sample, merge } from "effector";
import { patchHandler } from "./dragons.mjs";
import { readonly } from "./lib/readonly.mjs";
import { status, viewStatus } from "./lib/status.mjs";
function createRemoteOperation({
  handler,
  name = "unknown"
}) {
  const reset = createEvent({ name: `${name}.reset` });
  const execute = createEvent({ name: `${name}.execute` });
  const called = createEvent({ name: `${name}.called` });
  const $variables = createStore({}, {
    name: `${name}.variables`,
    sid: `apollo.${name}.$variables`,
    skipVoid: false
  });
  const executeFx = createEffect({
    name: `${name}.executeFx`,
    handler
  });
  const $status = status(executeFx, { name: `${name}.status`, sid: `apollo.${name}.$status` });
  const success = executeFx.done.map(({ params, result: data }) => ({ ...params, data }));
  const failure = executeFx.fail.map(({ params, error }) => ({ ...params, error }));
  sample({ clock: execute, fn: ({ variables }) => variables, target: $variables });
  sample({ clock: execute, target: executeFx });
  sample({ clock: reset, target: $status.reinit });
  patchHandler(executeFx, called);
  return {
    reset,
    $status: readonly($status),
    ...viewStatus($status),
    finished: {
      success,
      failure,
      finally: merge([
        success.map((payload) => ({ status: "done", ...payload })),
        failure.map((payload) => ({ status: "fail", ...payload }))
      ])
    },
    __: { execute, executeFx, called, $variables }
  };
}
export {
  createRemoteOperation
};
//# sourceMappingURL=remote_operation.mjs.map
